/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */

import { Response } from '@angular/http';
import { Component } from '@angular/core';
import { environment } from './../../../../../environments/environment';
import { SubscribeService } from './../../../services/subscribe/subscribe.service';
import { FormControl, FormGroup, FormBuilder, Validators, } from '@angular/forms';

/**
 *  jQuery variables
 */
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'martmax-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  providers: [SubscribeService],
})
export class FooterComponent {

  male: 'Male';
  female: 'Female';

  public errors: any;
  public subscribeRespose: any;
  public subscribeForm: FormGroup;

  constructor(
    public subscribeService: SubscribeService,
    private fb: FormBuilder,
  ) {

  }

  public ngOnInit() {
    this.createSubscribeForm();
  }

  public createSubscribeForm() {
    this.subscribeForm = this.fb.group({
      email: ['', [Validators.required]],
      gender: '',
    });
  }

  /**
   * subscribe service 
   * @param email 
   * @param gender 
   */
  public subscribe(email: string, gender: string) {
    this.subscribeService.store({
      email, gender,
    }).subscribe(
      (data) => {
        this.errors = null;
        $(".subscribe-form").hide(500);
        this.subscribeRespose = data[0];
        console.log(this.subscribeRespose);
      }, (errors) => {
        this.errors = errors.email[0];
      });
  }

  /**
   *  store gender 
   */
  public store(gender: string) {
    this.subscribe(this.subscribeForm.value.email, gender);
  }

  public goTop() {
    $("html,body").animate({ scrollTop: 0 }, 600);
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home-page/footer/footer.component.ts